import { useContext } from "react";
import UserContext from "../context/UserContext";
import CustomSpinner from "./CustomSpinner";

const LoginComponent = () => {
  const { loginError, loading, Login } = useContext(UserContext);

  return (
    <>
      {loading && <CustomSpinner />}
      <div className="mx-auto mt-6 w-full max-w-md rounded-2xl border border-black/10 bg-slate-50/80 p-6 shadow-2xl dark:border-white/10 dark:bg-slate-900/80">
        <h2 className="mb-3 text-center text-2xl font-semibold text-gray-900 dark:text-white">Iniciar sesión</h2>
        <p className="mb-5 text-center text-sm text-slate-500">
          Administra tus clientes fácilmente.
        </p>
        <button type="button" onClick={Login} className="flex w-full items-center justify-center gap-3 rounded-lg bg-white px-3 py-2 font-medium text-slate-700 shadow transition hover:bg-slate-100 dark:bg-slate-800 dark:text-white dark:hover:bg-slate-700">
          <span className="text-lg font-bold text-[#4285F4]">G</span>
          Continuar con Google
        </button>
        {loginError && (
          <p className="mt-3 rounded-lg bg-rose-500/10 px-3 py-2 text-center text-sm text-rose-700">
            Esta cuenta no está registrada en el sitio.
          </p>
        )}
      </div>
    </>
  );
};

export default LoginComponent;
